<script lang="ts" setup>
import type { IHomeHenceCard } from '@/utils/types'
const props = defineProps({
  data: Object as PropType<IHomeHenceCard>,
  arrow: {
    type: Boolean,
    default: true
  }
})
</script>

<template>
  <div class="cardItem">
    <nuxt-link :to="data?.link">
      <figure class="cardItem__pic">
        <Nimg :src="data?.image?.link" :alt="data?.image?.alt" :title="data?.image?.title">
        </Nimg>
      </figure>
    </nuxt-link>
    <div class="cardItem__category">{{ data?.category }}</div>
    <nuxt-link :to="data?.link" class="cardItem__link">{{ data?.title }}</nuxt-link>
    <nuxt-link :to="data?.link" class="cardItem__icon" v-if="props.arrow">
      <svg-icon name="icon-arrow-right2" />
    </nuxt-link>
  </div>
</template>

<style lang="scss" scoped>
.cardItem {
  &__pic {
    position: relative;
    padding-top: 100%;
    margin-bottom: toRem(12);

    img {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &__category {
    margin-bottom: toRem(12);
    font-size: toRem(14);
    color: $color-gray-1;
    line-height: 1.3;
  }

  &__link {
    margin-bottom: toRem(12);
    font-size: toRem(20);
    font-weight: 500;
    line-height: 1.4;
    @include dot-many-line(2);
  }

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: toRem(44);
    height: toRem(44);
    border: 1px solid $color-gray-line;
    border-radius: 50%;
    color: $color-brand-4_1;

    svg {
      width: toRem(40);
      height: toRem(40);
    }
  }
}
</style>
